<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="queryMaintainList" @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>保养任务
          </div>
          <div class="es-op-box">

            <el-date-picker style="float: left;width:300px" format="yyyy-MM-dd" v-model="dateTime" type="daterange"
              size="small" class="query" range-separator="至" start-placeholder="计划开始日期起始" end-placeholder="计划开始日期结束"
              clearable @clear="() => { this.dateTime = []; }"
              @change="() => { this.queryObj.pageNum = 1; loadMaintainList() }">
            </el-date-picker>
            <el-select style="float: left;" class="query" size="small" v-model="queryObj.systemId" placeholder="请选择系统专业"
              clearable filterable @clear="() => {
                delete this.queryObj.systemId
              }" @change="() => { this.queryObj.pageNum = 1; loadMaintainList() }">
              <el-option v-for="item in systems" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-select style="float: left;" class="query" size="small" v-model="queryObj.assetTypeId" placeholder="请选设备类型"
              clearable filterable @clear="() => {
                delete this.queryObj.assetTypeId
              }" @change="() => { this.queryObj.pageNum = 1; loadMaintainList() }">
              <el-option v-for="item in assetTypes" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>

            <el-select style="float: left;" class="query" size="small" v-model="queryState" placeholder="请选择状态" clearable
              filterable @clear="() => {
                this.queryState = null;
                delete this.queryObj.state
              }" @change="() => { this.queryObj.pageNum = 1; loadMaintainList() }">
              <el-option v-for="item in statesArr" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>

          </div>
          <br><br>
          <el-table :data="pageData.list" ref="maintainTable" show-overflow-tooltip border stripe size="mini"
            height="calc(100vh - 250px)" v-loading="loading">
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>

            <el-table-column prop="name" label="保养任务名称">
            </el-table-column>
            <el-table-column prop="orgName" label="组织">
            </el-table-column>
            <el-table-column prop="systemName" label="系统专业" width="80">
            </el-table-column>
            <el-table-column prop="assetTypeName" label="设备类型" width="90">
            </el-table-column>
            <el-table-column prop="planStartTime" label="计划开始时间">
            </el-table-column>
            <el-table-column prop="planEndTime" label="计划结束时间">
            </el-table-column>
            <el-table-column prop="finishCount" label="完成数量" width="70" align="center">
              <template slot-scope="scope">
                {{ scope.row.finishCount }}/{{ scope.row.totalCount }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="状态" width="70" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="stateFormat(scope.row, 1)">{{ scope.row.statename }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="140" align="center">
              <template slot-scope="scope">

                <el-link :underline="false" title="详情" @click="view(scope.row)" type="success"><i
                    class="el-icon-font el-icon-view"></i></el-link>

              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData" @change="
              (cpage) => {
                this.queryObj.pageNum = cpage
                this.loadMaintainList()
              }
            ">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!--查看保养任务详情-->
    <el-dialog :visible.sync="viewVisible" width="1200px" style="padding-top: 0px;">

      <span slot="title">
        <i class="el-icon-font el-icon-view el-icon--left"></i>保养任务详情
      </span>
      <el-tabs type="card">
            <el-tab-pane label="基本信息">
              <div v-loading="viewLoading">
              <el-descriptions
                :column="3"
                style="cursor: pointer; margin-bottom: 12px"
                size="mini"
                border
              >
               <el-descriptions-item label="所属组织" v-if="maintainInfo.orgName!=''&&maintainInfo.orgName!=null">{{
                    maintainInfo.orgName
                  }}</el-descriptions-item>
                  <el-descriptions-item label="所属系统" v-if="maintainInfo.systemName!=''&&maintainInfo.systemName!=null">{{
                    maintainInfo.systemName
                  }}</el-descriptions-item>
                  <el-descriptions-item label="设备类型" v-if="maintainInfo.assetTypeName!=''&&maintainInfo.assetTypeName!=null">{{
                    maintainInfo.assetTypeName
                  }}</el-descriptions-item>
                  <el-descriptions-item label="任务名称" v-if="maintainInfo.name!=''&&maintainInfo.name!=null">{{
                    maintainInfo.name
                  }}</el-descriptions-item>
                  <el-descriptions-item label="计划开始时间" v-if="maintainInfo.planStartTime!=''&&maintainInfo.planStartTime!=null">{{
                    maintainInfo.planStartTime
                  }}</el-descriptions-item>
                  <el-descriptions-item label="计划结束时间" v-if="maintainInfo.planEndTime!=''&&maintainInfo.planEndTime!=null">{{
                    maintainInfo.planEndTime
                  }}</el-descriptions-item>
                  <el-descriptions-item label="创建时间" v-if="maintainInfo.createTime!=''&&maintainInfo.createTime!=null">{{
                    maintainInfo.createTime
                  }}</el-descriptions-item>
                  <el-descriptions-item label="任务描述" v-if="maintainInfo.taskDes!=''&&maintainInfo.taskDes!=null">{{
                    maintainInfo.taskDes
                  }}</el-descriptions-item>
                  <el-descriptions-item label="当前状态" v-if="maintainInfo.orgName!=''&&maintainInfo.orgName!=null">
                    <div style="width: 200px">
                  <el-tag>{{ stateFormat(maintainInfo, 2) }}</el-tag>
                </div>
                  </el-descriptions-item>
              </el-descriptions>
              </div>
            </el-tab-pane>
          </el-tabs>
      <div class="es-op-box">
        <el-select style="float: left;margin-bottom: 20px;" class="query" size="small" v-model="statesType"
          placeholder="请选择是否完成" clearable filterable @clear="() => {
            this.statesType = null; loadMaintainAssetListView(this.maintainInfo.id)
          }" @change="() => { loadMaintainAssetListView(this.maintainInfo.id) }">
          <el-option v-for="item in statesDetailArr" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <el-table :data="pageDataForAssetView" show-overflow-tooltip border stripe size="mini" height="calc(70vh - 250px)"
        v-loading="loadingAssetTable">
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>

        <el-table-column prop="areaName" label="区域">
        </el-table-column>
        <el-table-column prop="assetName" label="设备名称">
        </el-table-column>
        <el-table-column prop="code" label="设备编码">
        </el-table-column>
        <el-table-column prop="chargePersonName" label="责任人">
        </el-table-column>
        <el-table-column prop="companionName" label="协作人">
        </el-table-column>
        <el-table-column prop="doneTime" label="完成时间">
        </el-table-column>
        <el-table-column prop="state" label="状态" width="70" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="stateFormatView(scope.row, 1)">{{ scope.row.statename }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="60" align="center">
          <template slot-scope="scope">

            <el-link :underline="false" title="详情" @click="viewAsset(scope.row)" type="success"><i
                class="el-icon-font el-icon-view"></i></el-link>

          </template>
        </el-table-column>

      </el-table>
    </el-dialog>

    <!--查看保养设备详情-->
    <el-dialog :visible.sync="viewVisibleAsset" width="800px" style="padding-top: 0px;">

      <span slot="title">
        <i class="el-icon-font el-icon-view el-icon--left"></i>保养设备详情
      </span>
      <el-tabs type="card">
            <el-tab-pane label="基本信息">
              <div v-loading="viewLoading">
              <el-descriptions
                :column="3"
                style="cursor: pointer; margin-bottom: 12px"
                size="mini"
                border
              >
              <el-descriptions-item label="区域" :labelStyle='labelStyle' v-if="maintainAssetInfo.areaName!=''&&maintainAssetInfo.areaName!=null">{{
                    maintainAssetInfo.areaName
                  }}</el-descriptions-item>
                  <el-descriptions-item label="设备名称" :labelStyle='labelStyle' v-if="maintainAssetInfo.assetName!=''&&maintainAssetInfo.assetName!=null">{{
                    maintainAssetInfo.assetName
                  }}</el-descriptions-item><el-descriptions-item label="设备编码" :labelStyle='labelStyle' v-if="maintainAssetInfo.code!=''&&maintainAssetInfo.code!=null">{{
                    maintainAssetInfo.code
                  }}</el-descriptions-item><el-descriptions-item label="责任人" :labelStyle='labelStyle' v-if="maintainAssetInfo.chargePersonName!=''&&maintainAssetInfo.chargePersonName!=null">{{
                    maintainAssetInfo.chargePersonName
                  }}</el-descriptions-item><el-descriptions-item label="协作人" :labelStyle='labelStyle' v-if="maintainAssetInfo.companionName!=''&&maintainAssetInfo.companionName!=null">{{
                    maintainAssetInfo.companionName
                  }}</el-descriptions-item><el-descriptions-item label="完成时间" :labelStyle='labelStyle' v-if="maintainAssetInfo.doneTime!=''&&maintainAssetInfo.doneTime!=null">{{
                    maintainAssetInfo.doneTime
                  }}</el-descriptions-item><el-descriptions-item label="完成情况描述" :labelStyle='labelStyle' v-if="maintainAssetInfo.doneDes!=''&&maintainAssetInfo.doneDes!=null">{{
                    maintainAssetInfo.doneDes
                  }}</el-descriptions-item><el-descriptions-item label="当前状态" :labelStyle='labelStyle'>
                    <div style="width: 200px">
                  <el-tag>{{ stateFormatView(maintainAssetInfo, 2) }}</el-tag>
                </div>
                    
                  </el-descriptions-item>
              </el-descriptions>
              <es-img :info="maintainAssetInfo" :fileList="fileListView" type="view"></es-img>
              </div>
            </el-tab-pane>
          </el-tabs>
    </el-dialog>


  </div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'

export default {
  name: 'maintainquery',
  props: ["funcs","paramId"],
  data () {
    return {
      //label样式
      labelStyle: { 'width': '120px' },
      orgTree: [],//所属组织
      statesArr: [{ id: 0, name: '未执行' }, { id: 1, name: '部分完成' }, { id: 2, name: '已完成' }],//状态
      statesDetailArr: [{ id: 0, name: '未完成' }, { id: 1, name: '已完成' }],
      statesType: null,
      queryState: null,
      systems: [],//系统专业
      assetTypes: [],//设备类型
      dateTime: [],//上报起止日期
      chargePersons: [],//责任人

      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      pageDataForAssetLeft: [],
      pageDataForAssetRight: [],
      pageDataForAssetView: [],
      editVisible: false,
      editVisibleAssetTable: false,
      editVisibleChargePerson: false,
      editDisable: false,//控件可否操作
      maintainInfo: {}, //保养任务信息
      maintainAssetInfo: {}, //保养设备信息

      tableFlag: null,
      viewVisible: false,
      viewVisibleAsset: false,

      loading: false,
      loadingAssetTable: false,

      editLoading: false,
      viewLoading: false,
      saving: false,
      url: '',
      fileListView: [],

    }
  },
  methods: {

    //页面初始化
    init () {
      this.loadSystemListAll()
      this.loadAssetTypeListAll()

      this.loadMaintainList()

      //弹出详情
      
      if (this.paramId != null) {
        this.viewVisible = false
        this.view({'id':this.paramId})
      }
    },

    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },

    //初始化系统下拉框
    loadSystemListAll () {
      this.$ajax.get('/base/system/list_all').then((msg) => {
        this.systems = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },
    //初始化设备类型下拉框
    loadAssetTypeListAll () {
      this.$ajax.get('/base/assettype/list_all').then((msg) => {
        this.assetTypes = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },

    //从后台查询任务列表
    loadMaintainList () {
      this.loading = true

      this.$set(this.queryObj, 'queryTimeStart', null);
      this.$set(this.queryObj, 'queryTimeEnd', null);
      //上报起止日期格式化
      if (this.dateTime != null && this.dateTime.length != 0) {

        this.$set(this.queryObj, 'queryTimeStart', dateutils.dateFormat("YYYY-mm-dd", this.dateTime[0]) + ' 00:00:00')
        this.$set(this.queryObj, 'queryTimeEnd', dateutils.dateFormat("YYYY-mm-dd", this.dateTime[1]) + ' 23:59:59')
      }

      this.formatQuerySate();//整理查询状态，使之适配后台

      this.$set(this.queryObj, 'orderBy', "create_time desc")
      this.$ajax.get('/buss/maintain/list', this.queryObj).then((msg) => {
        this.pageData = msg

        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    formatQuerySate () {
      delete this.queryObj.state

      if (this.queryState == 0) {//未执行
        this.queryObj.state = 0
      }
      if (this.queryState == 1) {//部分完成
        this.queryObj.state = 1
      }
      if (this.queryState == 2) {//已完成
        this.queryObj.state = 2
      }

    },

    queryMaintainList (orgIds) {
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.loadMaintainList()
    },

    //查看保养任务详情
    view (row) {
      this.viewVisible = true
      this.viewLoading = true
      this.fileListView = []
      this.statesType = null;
      this.loadMaintainAssetListView(row.id)//加载保养设备数据

      this.$ajax.get('/buss/maintain/load_detail', { id: row.id }).then((msg) => {
        this.maintainInfo = msg
        this.viewLoading = false
      }).catch(err => {
        this.$message.error(err)
        this.viewVisible = false
        this.viewLoading = false
      })
    },

    //查看保养设备详情
    viewAsset (row) {
      this.viewVisibleAsset = true
      this.viewLoading = true
      this.fileListView = []

      this.$set(this.maintainAssetInfo, 'chargePersonId', null)
      this.maintainAssetInfo = row

      //初始化图片
      if (this.maintainAssetInfo.attachImgs != null && this.maintainAssetInfo.attachImgs != '') {
        let temp = JSON.parse(this.maintainAssetInfo.attachImgs)
        temp.forEach(e => {
          this.fileListView.push(e.url + '&platform=web&token=' + this.$store.getUser().token)
        })
      }

      this.viewLoading = false

    },

    //显示状态，type=1列表用，type=2详情用
    stateFormat (row, type) {

      if (row.state == 0) {
        if (type == 1) {
          row.statename = "未执行"
          return "primary"
        }
        return '未执行'
      } else if (row.state == 1) {
        if (type == 1) {
          row.statename = "部分完成"
          return "primary"
        }
        return '部分完成'
      } else {
        if (type == 1) {
          row.statename = "已完成"
          return "success"
        }
        return '已完成'
      }
    },
    //显示状态，type=1列表用，type=2详情用
    stateFormatView (row, type) {

      if (row.state == 0) {
        if (type == 1) {
          row.statename = "未完成"
          return "primary"
        }
        return '未完成'
      } else {
        if (type == 1) {
          row.statename = "已完成"
          return "success"
        }
        return '已完成'
      }
    },

    //从后台查询保养设备列表
    loadMaintainAssetListView (maintainId) {

      this.loadingAssetTable = true
      this.$ajax.get('/buss/maintain/list_maintain_asset', { maintainId: maintainId, state: this.statesType }).then((msg) => {
        this.pageDataForAssetView = msg
        this.loadingAssetTable = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingAssetTable = false
      })

    },



  },
  mounted () {
    this.init()
  },
}
</script>
<style scoped></style>
